import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'

export type VariantColor =
  | 'success'
  | 'warning'
  | 'danger'
  | 'grey'
  | 'blue'
  | 'primary'
  | 'purple'
  | 'darkBlue'
  | 'secondaryRed'
  | 'fushia'
  | 'white'
  | 'secondaryBlue'
  | 'violet'
  | 'yellow'
  | 'secondaryDarkBlue'
  | 'primaryLight'
  | 'grey-light'
  | 'transparent'
  | 'brown'
  | 'orange'

type VariantColorMapping = {
  text: TailwindColor
  background: TailwindColor
  size?: 'small' | 'medium'
  hover?: TailwindColor
}

export const colorsMapping: Record<VariantColor, VariantColorMapping> = {
  danger: {
    text: tailwindColors.red.DEFAULT,
    background: tailwindColors.red.light.DEFAULT,
    hover: tailwindColors.red.light.DEFAULT
  },
  grey: {
    text: tailwindColors.grey.DEFAULT,
    background: tailwindColors.white.dark.DEFAULT,
    hover: tailwindColors.grey.light.DEFAULT
  },
  'grey-light': {
    text: tailwindColors.grey.DEFAULT,
    background: tailwindColors.grey.light.DEFAULT,
    hover: tailwindColors.grey.light.DEFAULT
  },
  success: {
    text: tailwindColors.green.DEFAULT,
    background: tailwindColors.green.light.DEFAULT,
    hover: tailwindColors.green.light.DEFAULT
  },
  warning: {
    text: tailwindColors.secondary.DEFAULT,
    background: tailwindColors.secondary.light.DEFAULT,
    hover: tailwindColors.secondary.light.DEFAULT
  },
  blue: {
    text: tailwindColors.blue.DEFAULT,
    background: tailwindColors.blue.light.DEFAULT,
    hover: tailwindColors.blue.light.DEFAULT
  },
  secondaryBlue: {
    text: tailwindColors.grey.DEFAULT,
    background: tailwindColors.blue.light.DEFAULT
  },
  darkBlue: {
    text: tailwindColors.primary.dark.DEFAULT,
    background: tailwindColors.primary.light.DEFAULT,
    hover: tailwindColors.primary.light.DEFAULT
  },
  secondaryDarkBlue: {
    text: tailwindColors.blue.light.DEFAULT,
    background: tailwindColors.blue.dark.DEFAULT,
    hover: tailwindColors.blue.dark.hover
  },
  primary: {
    text: tailwindColors.primary.DEFAULT,
    background: tailwindColors.primary.light.DEFAULT,
    hover: tailwindColors.primary.light.DEFAULT
  },
  purple: {
    text: tailwindColors.purple.DEFAULT,
    background: tailwindColors.purple.light.DEFAULT,
    hover: tailwindColors.purple.light.DEFAULT
  },
  secondaryRed: {
    text: tailwindColors.secondaryRed.DEFAULT,
    background: tailwindColors.secondaryRed.light.DEFAULT,
    hover: tailwindColors.secondaryRed.light.DEFAULT
  },
  fushia: {
    text: tailwindColors.fushia.DEFAULT,
    background: tailwindColors.fushia.light.DEFAULT,
    hover: tailwindColors.fushia.light.DEFAULT
  },
  white: {
    text: tailwindColors.grey.DEFAULT,
    background: tailwindColors.white.DEFAULT
  },
  violet: {
    text: tailwindColors.purple.active,
    background: tailwindColors.purple.light.DEFAULT
  },
  yellow: {
    text: tailwindColors.yellow.DEFAULT,
    background: tailwindColors.yellow.light
  },
  primaryLight: {
    text: tailwindColors.primary.DEFAULT,
    background: tailwindColors.primary.light.DEFAULT
  },
  transparent: {
    text: tailwindColors.black.DEFAULT,
    background: 'transparent'
  },
  brown: {
    text: tailwindColors.brown.DEFAULT,
    background: tailwindColors.brown.light.DEFAULT
  },
  orange: {
    text: tailwindColors.orange.DEFAULT,
    background: tailwindColors.orange.light.DEFAULT
  }
}

export const getFadeColor = (color: string, fadeNumber: number = 20): string =>
  `${color}${fadeNumber}`

// "#abc" -> "#aabbcc", lowercased: getFadeColor needs the 6-digit form to append its alpha digits
export const toLongHexColor = (hex: string): string =>
  (hex.length === 4
    ? `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`
    : hex
  ).toLowerCase()
